import axios from 'axios'
import { EVENT_BLACKLIST, USER_TOKEN } from "./CONSTANTS";

export const getEventBlacklists = (format) => {
  console.info("eventBlacklistServices > getEventBlacklists...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_BLACKLIST()+(format=='excel'?'?format=excel':''),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`,
        },
        responseType: format =='excel' ?'blob':'json'
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventBlacklists = (model) => {
  console.info("eventBlacklistServices > addEventBlacklists...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_BLACKLIST(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventBlacklists = (model) => {
  console.info("updateBlacklistServices > updateEventBlacklists...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_BLACKLIST(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventBlacklists = (uniqueKey) => {
  console.info("eventBlacklistServices > deleteEventBlacklists...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_BLACKLIST()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};